import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss'
})
export class BreadcrumbsComponent {
    links: any = {};
    vigencia : any;

    constructor(){
        this.links = environment.enlaces;
        this.vigencia = new Date().getFullYear()-1;
    }
}
